import { useId } from 'react';

import { Icon } from '@/shared/types/icon';

export const Azure = ({ size = 24, ...rest }: Icon) => {
  const id = useId();
  const gradientA = `azure-grad-a-${id}`;
  const gradientB = `azure-grad-b-${id}`;
  const gradientC = `azure-grad-c-${id}`;

  return (
    <svg
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      {...rest}
    >
      <path
        d="M9.5252 1.86961H16.9646L9.24177 24.7516C9.1624 24.9867 9.01128 25.1911 8.8097 25.3358C8.60812 25.4805 8.36622 25.5584 8.11806 25.5585H2.32834C2.14032 25.5585 1.95499 25.5137 1.78769 25.4279C1.62039 25.3421 1.47593 25.2177 1.36625 25.065C1.25658 24.9122 1.18485 24.7356 1.15699 24.5496C1.12913 24.3637 1.14595 24.1738 1.20606 23.9956L8.4012 2.67647C8.48054 2.44124 8.63168 2.23683 8.83332 2.09203C9.03497 1.94723 9.27695 1.86962 9.5252 1.86961Z"
        fill={`url(#${gradientA})`}
      />
      <path
        d="M20.3358 17.2173H8.53861C8.42893 17.2171 8.32176 17.2501 8.23105 17.3117C8.14035 17.3734 8.07032 17.4609 8.03008 17.5629C7.98984 17.665 7.98126 17.7768 8.00546 17.8837C8.02966 17.9907 8.08552 18.0879 8.16575 18.1627L15.7463 25.2381C15.967 25.444 16.2576 25.5585 16.5595 25.5584H23.2395L20.3358 17.2173Z"
        fill="#0078D4"
      />
      <path
        d="M9.52522 1.86961C9.27426 1.86865 9.02957 1.94796 8.82688 2.09595C8.6242 2.24394 8.47415 2.45285 8.39864 2.69219L1.21493 23.9762C1.15078 24.155 1.13064 24.3466 1.15621 24.5349C1.18179 24.7231 1.25232 24.9024 1.36185 25.0576C1.47138 25.2128 1.61668 25.3394 1.78546 25.4266C1.95424 25.5137 2.14153 25.559 2.3315 25.5585H8.27064C8.49184 25.5189 8.69859 25.4214 8.86976 25.2759C9.04093 25.1303 9.1704 24.9419 9.24493 24.7299L10.6775 20.5079L15.7946 25.2808C16.0091 25.4581 16.2781 25.5562 16.5564 25.5585H23.2115L20.2926 17.2173L11.7838 17.2193L16.9915 1.86961H9.52522Z"
        fill={`url(#${gradientB})`}
      />
      <path
        d="M19.0272 2.67532C18.948 2.44047 18.7971 2.2364 18.5957 2.09186C18.3944 1.94731 18.1528 1.86958 17.9049 1.86961H9.61377C9.86161 1.86962 10.1032 1.94737 10.3045 2.09191C10.5059 2.23645 10.6568 2.4405 10.7361 2.67532L17.9315 23.9953C17.9916 24.1735 18.0085 24.3635 17.9807 24.5495C17.9528 24.7355 17.8811 24.9122 17.7714 25.065C17.6618 25.2177 17.5173 25.3422 17.35 25.4281C17.1826 25.5139 16.9973 25.5587 16.8092 25.5588H25.1006C25.2887 25.5587 25.474 25.5139 25.6413 25.428C25.8086 25.3421 25.953 25.2176 26.0627 25.0648C26.1723 24.9121 26.244 24.7354 26.2718 24.5494C26.2996 24.3634 26.2828 24.1735 26.2226 23.9953L19.0272 2.67532Z"
        fill={`url(#${gradientC})`}
      />
      <defs>
        <linearGradient
          id={gradientA}
          x1="12.2366"
          y1="3.62504"
          x2="4.51063"
          y2="26.4496"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#114A8B" />
          <stop offset="1" stopColor="#0669BC" />
        </linearGradient>
        <linearGradient
          id={gradientB}
          x1="14.6501"
          y1="14.2619"
          x2="12.8629"
          y2="14.8662"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0.3" />
          <stop offset="0.071" stopOpacity="0.2" />
          <stop offset="0.321" stopOpacity="0.1" />
          <stop offset="0.623" stopOpacity="0.05" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={gradientC}
          x1="13.6672"
          y1="2.95932"
          x2="22.1481"
          y2="25.5539"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3CCBF4" />
          <stop offset="1" stopColor="#2892DF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
